// ======================================================================
// File Name       : livePerformance
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/ActionTypes';

export function getLivePerformanceList(livePerformanceList, recordNum) {
  return {
    type: ActionTypes.LIVE_PERFORMANCE_LIST,
    livePerformanceList,
    recordNum,
  };
}

export function getLivePerformanceUserCount(liveListUserCount) {
  return {
    type: ActionTypes.LIVE_PERFORMANCE_LIST_USER_COUNT,
    liveListUserCount,
  };
}

export function getLivePerformanceDetail(
  liveList,
  liveReserveDetail,
  userAttributeList,
  recordNumRelation,
) {
  return {
    type: ActionTypes.LIVE_PERFORMANCE_DETAIL,
    liveList,
    liveReserveDetail,
    userAttributeList,
    recordNumRelation,
  };
}

export function getLivePerformanceDetailPaging(
  liveList,
) {
  return {
    type: ActionTypes.LIVE_PERFORMANCE_DETAIL_PAGING,
    liveList,
  };
}

// #7129 START
export function resetLivePerformanceDetail() {
  return {
    type: ActionTypes.RESET_LIVE_PERFORMANCE_DETAIL,
  };
}
// #7129 END